import type { CourseType, CourseStatus, Requirement, Bilingual, LabeledType } from '@/types/domain';

/** Course-type chips. */
export const TYPE_LABEL: Record<CourseType, LabeledType> = {
  online: { label: { en: 'Online', th: 'ออนไลน์' }, badge: 'slate' },
  onsite: { label: { en: 'Onsite', th: 'ภาคปฏิบัติ' }, badge: 'clay' },
  hybrid: { label: { en: 'Hybrid', th: 'ผสมผสาน' }, badge: 'sage' },
};

/** Course-status pills. */
export const STATUS_LABEL: Record<CourseStatus, { en: string; badge: LabeledType['badge'] }> = {
  active: { en: 'Active', badge: 'sage' },
  draft: { en: 'Draft', badge: 'gray' },
  readonly: { en: 'Read Only', badge: 'ochre' },
  hidden: { en: 'Hidden', badge: 'line' },
};

/** Certificate-requirement labels. */
export const REQ: Record<Requirement, Bilingual> = {
  pretest: { en: 'Take the pre-test', th: 'ทำแบบทดสอบก่อนเรียน' },
  lessons: { en: 'Complete all lessons', th: 'เรียนครบทุกบทเรียน' },
  attend: { en: 'Attend onsite session', th: 'เข้าร่วมภาคปฏิบัติ' },
  posttest: { en: 'Pass post-test', th: 'ผ่านแบบทดสอบหลังเรียน' },
  eval: { en: 'Complete evaluation', th: 'ทำแบบประเมิน' },
  approval: { en: 'Instructor approval', th: 'อาจารย์อนุมัติ' },
};
